import { render, staticRenderFns } from "./myFooter.vue?vue&type=template&id=18a52553&"
import script from "./myFooter.vue?vue&type=script&lang=js&"
export * from "./myFooter.vue?vue&type=script&lang=js&"
import style0 from "./myFooter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports